import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

// Below this width the sidebar stops being a column beside the content and
// becomes a drawer over it. Matches Tailwind's `md`.
const MOBILE_BREAKPOINT = 768;

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  // Two separate ideas, deliberately:
  //   isCollapsed   desktop — icons only vs full width
  //   isMobileOpen  mobile  — drawer shown vs hidden
  // Sharing one flag would make closing the drawer also collapse the desktop
  // sidebar the next time the window is widened.
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      // Widening the window should never leave a stray drawer open over the page
      if (!mobile) setIsMobileOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <SidebarContext.Provider
      value={{ isCollapsed, setIsCollapsed, isMobile, isMobileOpen, setIsMobileOpen }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
